module.exports = __webpack_public_path__ + "media/spin_the_wheel-e9ad3d26d66d5a9f6f04d26fec45f1eb.mp3";